import { getSystemList } from "@iewccouk/Services/OrderService";
import setFieldValue from "@iewccouk/Store/Handlers/RfqRequestQuote/SetFieldValue";
import { CustomActions, CustomState } from "@iewccouk/Store/Reducers";
import {
    fields,
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormItemsBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    requestQuoteStyles,
    setRequestFormEffects,
    validateFieldBy
} from "@iewccouk/Widgets/RfqRequestQuote/FormBaseComponent";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Select from "@insite/mobius/Select";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const styles = {
    ...requestQuoteStyles.selectFields,
};

const mapStateToProps = (customState: CustomState) => ({
    typeOfRequest: customState.customRequestQuoteForm.fieldValues.typeOfRequest,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const TypeOfRequestWidget: React.FC<Props> = ({ fields: widgetFields, typeOfRequest, setFieldValue: widgetSetFieldValue }) => {
    const { label, hintText, isRequired, typesOfRequest } = widgetFields;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, typeOfRequest, "typeOfRequest", () =>
        validateFieldBy(isRequired, label, typeOfRequest, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        widgetSetFieldValue({ key: "typeOfRequest", value: event.target.value });
    };

    React.useEffect(() => {
        if (typesOfRequest?.length === 1) {
            widgetSetFieldValue({ key: "typeOfRequest", value: (typesOfRequest as any)[0].fields.item });
        }
    }, []);

    return typesOfRequest?.length > 1 ? (
        <Select
            {...styles}
            label={label}
            required={isRequired}
            value={typeOfRequest || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            placeholder={hintText || ""}
        >
            <option value="" {...(isRequired && { disabled: true })}>
                {translate(hintText)}
            </option>
            {typesOfRequest.map((item: any) => (
                <option key={item.fields.item} value={item.fields.item}>
                    {item.fields.item}
                </option>
            ))}
        </Select>
    ) : null;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(TypeOfRequestWidget),
    definition: {
        group: "Request a Quote Form" as any,
        icon: "FormField",
        fieldDefinitions: [
            getRfqFormLabelBuilt("Type of request"),
            getRfqFormHintTextBuilt("Please select"),
            {
                name: fields.typesOfRequest,
                displayName: "Types of request",
                editorTemplate: "ListField",
                defaultValue: [],
                getDisplay: (item: HasFields) => {
                    return item.fields.item;
                },
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "item",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
            getRfqFormCheckboxBuilt(),
        ],
    },
};

export default widgetModule;
